import React, { useState, useEffect } from 'react';
import { Form, Select, Input } from 'antd';
import { useRefCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';
import type { SelectProps } from 'antd';

interface FormItemProps {
  form: any
}

const LectureSubjectFormItem = ({form}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [codeList, setCodeList] = useState<SelectProps['options']>([]);

  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList: lectureSubjectList } = useRefCode({field:'lecture_subject1'});  

  /* ======================================================
  * events
  * ====================================================== */  

  /* ======================================================
  * effects
  * ====================================================== */  
  useEffect(() => {
    const options = 
      lectureSubjectList?.filter((item) => item.status_type === 'AV' || form.getFieldValue("lecture_subject1") == item.name).map((item) => {return {value: item.name, label: item.status_type == 'AV' ? item.value : <span style={{color:'red'}}>{item.value}</span>, sort: item.display_sort, option:item.option}}) || [];
    setCodeList(options);
  }, [lectureSubjectList, form]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="lecture_subject1" style={{ width:'180px', display: 'inline-block', marginRight: '5px' }}>
        <Select 
          placeholder="강의주제 선택" 
          allowClear 
          showSearch={true}
          optionFilterProp="label"
          options={codeList} 
          /*filterSort={(optionA, optionB) => optionA.sort - optionB.sort}*/
          />
      </Form.Item> 
      <Form.Item name="lecture_subject_memo" style={{ width:'200px', display: 'inline-block', marginRight: '5px' }}>
        <Input type="text" placeholder='강의메모'/>  
      </Form.Item> 
   
    </>
  );
};

export default LectureSubjectFormItem;
